import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from "@angular/router";
import {Location} from '@angular/common';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {Category} from "../type/category";

@Component({
    selector: 'app-company-category-edit',
    templateUrl: './company-category-edit.component.html',
})
export class CompanyCategoryEditComponent implements OnInit {

    node = 'company-category';
    companyCategory: Category = Category;
    companyCategories: [Category] = [Category];

    constructor(private dataService: DataService,
                private apiService: ApiService,
                private route: ActivatedRoute,
                private location: Location) {
    }

    ngOnInit(): void {
        this.dataService.refresh();
        this.getAll();
        this.route.params
            .subscribe(
                (params: Params) => {
                    this.apiService.getUsingId(this.node, +params['id'])
                        .subscribe((response) => {
                            this.dataService.updateActiveRequestNo(-1);
                            this.companyCategory = response.json().data[0];
                            // this.parent_id = response.json().data[1];
                        });
                }
            );
    }

    onFormSubmit() {
        this.apiService.update(this.node, [this.companyCategory.company_category_id], this.companyCategory)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form');
                    } else {
                        alert('Success: Company Category updated successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    getAll(): void {
        this.apiService.getAll(this.node)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.companyCategories = [Category];
                } else {
                    this.companyCategories = response.json().data;
                }
            });
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/company-category/company-category-edit.component.ts